<template>
  <div class="bot-inicio p-6">
    <!----Alerta para plano free----->
    <b-alert
      variant="primary"
      :show="showAlertFree()"
      dismissible
      @dismissed="showAlertFree = false"
    >
      <h4 class="alert-heading">
        Recurso não disponivel para o plano de teste
      </h4>
      <div class="alert-body">
        <span>O Assistente IA esta disponiveis apartir do plano Premium. Por enquanto você apenas testá-lo.</span>
      </div>
    </b-alert>

    <b-card class="shadow rounded-2xl">
      <template v-if="lojas.length === 0">
        <div class="text-center py-5">
          <b-icon
            icon="shop"
            variant="danger"
            font-scale="3"
          />
          <h4 class="mt-3">
            Você ainda não tem nenhuma loja cadastrada
          </h4>
          <p class="text-muted">
            Cadastre uma loja para liberar a criação do seu assistente inteligente.
          </p>
          <b-button
            variant="primary"
            @click="irParaCadastroLoja"
          >
            Cadastrar loja
          </b-button>
        </div>
      </template>

      <template v-else>
        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <div>
            <h4 class="mb-1">
              Seus Assistentes Inteligentes
            </h4>
            <p class="text-muted mb-0">
              Gerencie ou crie assistentes personalizados para as suas lojas.
            </p>
          </div>
          <b-button
            variant="outline-primary"
            size="sm"
            class="rounded-pill mt-2 mt-md-0"
            @click="criarBot"
          >
            + Novo Assistente
          </b-button>
        </div>

        <div v-if="bots.length">
          <b-row>
            <b-col
              v-for="bot in bots"
              :key="bot.id"
              cols="12"
              md="6"
              class="mb-3"
            >
              <b-card class="bot-card">
                <div class="d-flex align-items-center">
                  <img
                    :src="bot.avatar"
                    alt="avatar-bot"
                    class="rounded-circle mr-3"
                    style="width: 56px; height: 56px; object-fit: cover;"
                  >
                  <div>
                    <h5 class="mb-1">
                      {{ bot.nome }}
                    </h5>
                    <b-badge
                      variant="info"
                      class="mb-1"
                    >
                      {{ bot.tipo }}
                    </b-badge>
                    <div><small class="text-muted">Loja: {{ bot.loja }}</small></div>
                  </div>
                </div>
                <div class="text-center mt-3">
                  <b-button
                    variant="outline-primary"
                    block
                    @click="editarBot(bot.id)"
                  >
                    ✏️ Editar
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <div
          v-else
          class="text-center"
        >
          <p class="mb-2">
            Você ainda não criou seu Assistente. Deseja começar agora?
          </p>
          <b-button
            variant="success"
            @click="criarBot"
          >
            Criar novo Assistente
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import { getBots } from '../../../functions/basics/bot'

export default {
  name: 'BotInicio',
  data() {
    return {
      lojas: [],
      bots: [],
    }
  },
  created() {
    this.buscarLojas()
  },
  methods: {
    showAlertFree() {
      if (getUserData().role === 'admin' && getUserData().id >= 714 && getUserData().id <= 740) {
        return true
      }
      return false
    },
    async buscarLojas() {
      // Simulação de dados - Substitua pela API real
      this.lojas = [{ id: 1, nome: 'teste' }]
      const userData = JSON.parse(localStorage.getItem('userData'))
      this.bots = await getBots(userData.id)
      console.log(this.bots)
    },
    irParaCadastroLoja() {
      this.$router.push('/stores')
    },
    criarBot() {
      this.$router.push('/bot/create')
    },
    editarBot(botId) {
      this.$router.push(`/bot/edit/${botId}`)
    },
  },
}
</script>

  <style scoped>
  .b-card {
    border-radius: 1rem;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
  }

  .b-button {
    border-radius: 0.5rem;
    font-weight: 500;
  }

  .b-badge {
    font-size: 0.75rem;
    padding: 0.35em 0.6em;
    text-transform: uppercase;
  }

  .bot-inicio h4 {
    font-weight: 600;
  }

  .bot-inicio {
    max-width: 800px;
    margin: auto;
  }
  .bot-card {
    padding: 1.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-radius: 1rem;
    transition: transform 0.2s ease;
  }

  .bot-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  .bot-card img {
    margin-bottom: 1rem;
  }

  .bot-card h5 {
    margin-bottom: 0.25rem;
    font-weight: 600;
  }

  .bot-card .b-badge {
    margin-bottom: 0.25rem;
  }

  .bot-card small {
    color: #6c757d;
  }

  </style>
